module.exports = __webpack_public_path__ + "static/momentum_icon-2a558cf97a9cdda3b1c6865e4bdd6544.svg";